import {
  CollectiblePageContentBlock,
  collectiblePageContentBlocks,
} from 'app/blocks'
import { RichText } from 'app/blocks/rich-text'
import { gql } from 'graphql-request'

import { Collectible } from './list'

export const createCollectiblePageQuery = () => {
  const collectionQuery = gql`
    ${collectiblePageContentBlocks}
    query getCollectible($slug: String!) {
      Collectibles(where: { slug: { equals: $slug } }, limit: 1) {
        docs {
          id
          title
          quarter
          slug
          hasContent
          pageContent {
            __typename
            ...richTextFragment
            ...imageFragment
            ...callToActionFragment
            ...collectibleProgressFragment
          }
          terms {
            __typename
            ...richTextFragment
          }
          hero {
            sizes {
              thumbnail2x {
                url
              }
            }
          }
        }
      }
    }
  `
  return {
    query: collectionQuery,
    mapToPage,
  }
}

export interface CollectiblePageProps extends Omit<Collectible, 'href'> {
  id: string
  pageContent: CollectiblePageContentBlock[]
  hasContent: boolean
  terms: RichText[]
  heroImage: string
}

const mapToPage = (data: any): CollectiblePageProps | null => {
  const item = data.Collectibles?.docs?.[0]
  if (!item) return null
  return {
    id: item.id || '',
    title: item.title || '',
    heroImage: item.hero?.sizes?.thumbnail2x?.url || '',
    pageContent: item.pageContent || [],
    hasContent: item.hasContent || false,
    terms: item.terms || [],
    quarter: item.quarter || '',
    image: item.hero?.sizes?.thumbnail2x?.url || '',
  }
}
